import { Api } from '@shared/api/Api';

export class TradeOrder {
    private static _basePath = '/TradeOrder';

    public static getMethods(parentPath: string) {
        const basePath = `${parentPath}${TradeOrder._basePath}`;
        return {
            async getTradeOrders(page: number, pageSize: number) {
                const path = `/getTradeOrders?&page=${page}&pageSize=${pageSize}`;
                return await Api.get<any>({
                    path: `${basePath}${path}`,
                });
            },

            async getTradeOrder(tradeOrderId: number) {
                const path = `/getTradeOrder?&tradeOrderId=${tradeOrderId}`;
                return await Api.get<any>({
                    path: `${basePath}${path}`,
                });
            },

            async getTradeOrderByJobId(jobId: number) {
                const path = `/getTradeOrderByJobId?jobId=${jobId}`;
                return await Api.get<any>({
                    path: `${basePath}${path}`,
                });
            },

            async createBulkTradeOrder(body: any) {
                const path = '/CreateBulkTradeOrder';
                return await Api.post<string>({
                    path: `${basePath}${path}`,
                    body,
                });
            },

            async createTradeOrder(body: any) {
                const path = '/CreateTradeOrder';
                return await Api.post<string>({
                    path: `${basePath}${path}`,
                    body,
                });
            },

            async updateTradeOrder(body: any) {
                const path = '/updateTradeOrder';
                return await Api.put<string>({
                    path: `${basePath}${path}`,
                    body,
                });
            },
        };
    }
}
